/**
 * Build a human-readable TOC version string from major/minor numbers.
 *
 * @param tocMajorVersion - Major version number for the TOC.
 * @param tocMinorVersion - Minor version number for the TOC (zero-padded to 4 digits).
 * @param isBackupVersion - When true, append a backup indicator to the string.
 * @returns A formatted version string like `1.0001` or `1.0001 - backup version`.
 */
export const tocVersionString = (
  tocMajorVersion: number = 0,
  tocMinorVersion: number = 0,
  isBackupVersion: boolean = false,
): string => {
  let version = `${tocMajorVersion}.${tocMinorVersion.toString().padStart(4, "0")}`;
  if (isBackupVersion) version += " - backup version";
  return version;
};
